import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Card } from '../../../../design/card/card/S_Cards';
import { Loader } from '../../../components/Loader';
import { toLocaleDateTimeString } from '../../../helpers/date.helpers';
import { useDatasetPermissions } from '../datasets.permissions';
import { IDatasetDetails } from '../datasetsDetails.store';

interface IDatasetDetailsInformationProps {
  details: IDatasetDetails;
  isLoading: boolean;
}

export const DatasetDetailsInformation = observer(({ details, isLoading }: IDatasetDetailsInformationProps): ReactElement => {
  const { t } = useTranslator();
  const datasetsPermissions = useDatasetPermissions();

  const canSeeCreatedBy = datasetsPermissions.canSeeDatasetCreatedBy().allowed;

  return (
    <S_Card className='card-with-list'>
      <div className='info'>
        <h5>{t('informations')}</h5>
        <Loader isLoading={isLoading}>
          <div className='list-row first'>
            <div className='left'>{t('status')}</div>
            <div className='right'>{t(`dataset_status_${details.status}`)}</div>
          </div>
          <div className='list-row'>
            <div className='left'>{t('createdDate')}</div>
            <div
              className='right'
              id='created-date-cell'
            >
              {toLocaleDateTimeString(details.createdDate)}
            </div>
          </div>
          <div className='list-row'>
            <div className='left'>{t('number_of_images')}</div>
            <div
              className='right'
              id='images-count-cell'
            >
              {details.imagesCount}
            </div>
          </div>
          <div className='list-row'>
            <div className='left'>{t('size_of_images')}</div>
            <div className='right'>{(details.imagesSize || 0).toFixed(2)}</div>
          </div>
          {canSeeCreatedBy && (
            <div className='list-row'>
              <div className='left'>{t('created_by')}</div>
              <div className='right'>{details.createdBy}</div>
            </div>
          )}
        </Loader>
      </div>
    </S_Card>
  );
});
